import React from 'react'
import { Button, Popconfirm } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import { deleteData } from '../../../../resources'

export default function EmtBoxDeleteRecord({ record, box, retrieveBoxes = () => { } }) {
    const handleDelete = () => {
        console.log(box)
        console.log(record)
        deleteData(`emt-box/delete-protocolo/${box._id}/${record.key}/`).then((res) => {
            console.log('Record deleted:', res);
        }).catch((error) => {
            console.error('Error deleting record:', error);
        });
        retrieveBoxes()
    }
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center'}}>
            <Popconfirm
                title="Seguro que quieres eliminar este registro?"
                onConfirm={handleDelete}
                okText="Sí"
                cancelText="No"
            >

                <Button ghost shape='round' danger className='btnIconCentered'>
                    <DeleteOutlined style={{ color: 'red' }} />
                </Button>
            </Popconfirm>
        </div>
    )
}
